// src/templates.js

/**
 * Define an array of design templates for CarouselGenerator.
 * Each template has:
 *  - id: unique identifier
 *  - name: human‑friendly label
 *  - previewUrl: path to a thumbnail image
 *  - style: Tailwind utility strings for each part of the Slide component
 */

export const templates = [
    {
      id: 'big_bold_basic',
      name: 'Big Bold Basic',
      previewUrl: '/previews/big_bold_basic.png',
      style: {
        container:    'relative w-full pt-[125%] bg-black font-roboto text-white',
        inner:        'absolute top-0 left-0 w-full h-full flex flex-col items-start justify-center p-[100px]',
        titleMain:    'uppercase tracking-wide text-[86px] font-extrabold leading-none',
        titleSub:     'text-[58px] font-medium mt-[40px] leading-tight',
        contentMain:  'uppercase tracking-wide text-[72px] font-black leading-none',
        contentBody:  'text-[43px] font-extralight mt-[40px] leading-tight',
        arrow:        'absolute bottom-[100px] right-[100px] text-[80px] select-none'
      }
    },
    {
      id: 'namaste',
      name: 'Namaste',
      previewUrl: '/previews/namaste.png',
      style: {
        // full‑slide wrapper, square via parent aspect, bg & text color
        container: 'relative w-full pt-[125%] bg-[#DEDFDA] text-[#404040]',
    
        // inner flexbox, full inset, padding adjusts per breakpoint
        inner: 'absolute top-0 left-0 w-full h-full flex flex-col items-start justify-center p-[100px]',
    
        titleMain:    'font-libre-caslon tracking-normal text-[86px] leading-none p-[20px]',
        titleSub:     'font-inter text-[58px] font-extralight mt-[40px] leading-tight p-[20px]',
        contentMain:  'font-libre-caslon uppercase tracking-wide text-[72px] leading-none',
        contentBody:  'font-inter text-[43px] font-extralight mt-[40px] leading-tight py-[20px]',
        arrow:        'absolute bottom-[100px] right-[100px] text-[80px] select-none',
        topLine:    'absolute left-[100px] right-[100px] top-[60px] h-px bg-[#404040] px-[100px]',
        bottomLine: 'absolute left-[100px] right-[100px] bottom-[60px] h-px bg-[#404040]'
      }
    }
    
  ];
  
  // Optional: set default export
  export default templates;
  